<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<template>
  <div class="mt-16 mb-16 text-center">
    <h1>404 - {{ t("errors.notFoundPage.pageDoesntExist") }}</h1>
    <p>{{ t("errors.notFoundPage.couldntBeFound") }}.</p>
    <router-link to="/">{{ t("errors.notFoundPage.homePage") }}</router-link>
  </div>
</template>
